import { c as _c } from "react/compiler-runtime";
import type { IconProps } from '../types';
const IcoDankort24 = t0 => {
  const $ = _c(5);
  const {
    "aria-label": ariaLabel,
    className
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <g><path fillRule="evenodd" clipRule="evenodd" d="M8.11465 6.85033H1.42004C2.50033 5.58566 4.10591 4.78247 5.89593 4.78247H15.4381C17.2275 4.78247 18.8328 5.58566 19.913 6.85003H14.9473L12.4534 9.44972C12.2697 7.45323 10.4842 6.85033 8.11465 6.85033ZM17.1062 10.2338L20.1668 7.16887C20.8924 8.14722 21.3224 9.35762 21.3224 10.6664C21.3224 11.9065 20.9364 13.0577 20.2792 14.0074L17.1062 10.2338ZM4.21047 9.36717H7.29113C7.98086 9.36717 8.54233 9.67588 8.3188 10.4715C8.09293 11.2759 7.78756 11.6937 6.77829 11.6937H3.36428L4.21047 9.36717ZM14.968 14.3251H20.0435C18.9645 15.6808 17.3011 16.5513 15.4381 16.5513H5.89591C4.03228 16.5513 2.36849 15.6804 1.28955 14.3247H7.25363C10.2462 14.3247 11.8426 13.2645 12.3305 10.9918L14.968 14.3251Z" fill="#E21F28" /></g>;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <defs><clipPath id="a"><rect width={21.333} height={21.333} fill="#fff" /></clipPath></defs>;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== ariaLabel || $[3] !== className) {
    t3 = <svg width={22} height={22} viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg" aria-label={ariaLabel} className={className} role="img" data-colored={true}>{t1}{t2}</svg>;
    $[2] = ariaLabel;
    $[3] = className;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  return t3;
};
export default IcoDankort24;